<template>
    <li class="layer" :class="{ selected }">
        <div class="row" :class="children ? 'haschildren' : 'hasnochildren'">
            <button v-if="children" class="caret" :class="{ rotated: isOpen }" title="Toggle" @click.stop="toggle">▾</button>
            <span class="thumb vector" :style="{ background: selected.fill }">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M4 20l6-6 4 4 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="4" cy="20" r="2" fill="currentColor" />
                    <circle cx="10" cy="14" r="2" fill="currentColor" />
                    <circle cx="14" cy="18" r="2" fill="currentColor" />
                    <circle cx="20" cy="12" r="2" fill="currentColor" />
                </svg>
            </span>
            <span class="label">Frame</span>
            <span class="meta">800 × 520</span>
        </div>
    </li>
</template>

<script>
export default {
    name: "FrameComp",
    props: {
        selected: {
            type: Boolean,
            required: true
        },
        children: {
            type: Array,
            required: false
        }
    }
}
</script>

<style scoped>
.layer .row { display: grid; align-items: center; gap: 8px; padding: 6px 8px; border: 1px solid var(--border); background: var(--panel); border-radius: 6px; }
.haschildren { grid-template-columns: 16px 20px 1fr auto; }
.hasnochildren { grid-template-columns: 20px 1fr auto; }
.layer.group .row { background: var(--panel-2); }
.layer.selected .row { border-color: var(--accent, #5b8cff); background: var(--panel-selected); }
.layers { list-style: none; margin: 0; padding: 0; display: grid; gap: 4px; }
.layer { border-radius: 6px; }
.caret { width: 16px; text-align: center; color: var(--muted); transition: transform 160ms ease; display: inline-block; background: transparent; border: 0; padding: 0; cursor: pointer; font: inherit; }
.caret.rotated { transform: rotate(-90deg); }
.caret.placeholder { color: transparent; }
.thumb { width: 20px; height: 20px; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center; font-size: 11px; color: var(--muted); border: 1px solid var(--border); background: var(--panel-2, #1c2738); }
.thumb.board { border-style: dashed; }
.thumb.color { border: 1px solid var(--border); background: #ffffff; }
.thumb.text { font-weight: 700; }
.thumb.vector svg { width: 14px; height: 14px; display: block; }
.label { color: var(--text); font-size: 12px; }
.meta { color: var(--muted); font-size: 11px; }
</style>